import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import React, { useEffect, useRef } from "react";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";

const TablaBuscarProveedor = ({ datos }) => {
  const { token } = useContextUsuario();
  const { setListaProveedor , ActualizarLista } = useContextEmpleado();
  const tableRef = useRef();
  useEffect(() => {
    $(tableRef.current).DataTable({
      data: datos,
      columns: [
        { targets: 0, title: "Id", data: "id" },
        { targets: 1, title: "Nombre", data: "nombre" },
        { targets: 2, title: "RTN", data: "rtn" },
        {
          targets: 3,
          title: "Teléfono / Contacto",
          data: "proveedorTelefonos",
          render: (telefonos) => {
            if (!telefonos || telefonos.length === 0) return "Sin datos";
            return telefonos
              .map(t => `${t.telefono} (${t.contacto})`)
              .join("<br>");
          }
        },
        { targets: 4, title: "Correo", data: "correo" }
      ],
      paging: true,
      lengthChange: true,
      pageLength: 10,
      searching: true,
      ordering: true,
      info: true,
      autoWidth: true,
      buttons: ["copy", "csv", "excel", "pdf", "print"],
      dom:
        "<'row mb-3'<'col-sm-12 col-md-6 text-left'B><'col-sm-12 col-md-6 text-right'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
      responsive: true,
      language: {
        decimal: "",
        emptyTable: "No hay información",
        info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
        infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
        infoFiltered: "(Filtrado de _MAX_ total entradas)",
        infoPostFix: "",
        thousands: ",",
        lengthMenu: "Mostrar _MENU_ Entradas",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        zeroRecords: "Sin resultados encontrados",
        search: "Buscar:",
        paginate: {
          first: "|<<",
          last: ">>|",
          next: ">>",
          previous: "<<",
        },
      },
      destroy: true,
    });
    //}
  }, [datos]);

  return (
    <div className="table-responsive">
      <table
        ref={tableRef}
        id="proveedores"
        className="table table-bordered table-hover"
      ></table>
    </div>
  );
};

export default TablaBuscarProveedor;